<div class="TotemWidget TotemWidgetWelcome card">
    <div class="card-body display-flex justify-content-center align-items-center
        {{ background || image ? 'text-white' : '' }}
        {{getBackgroundClass() ? 'bg-' + getBackgroundClass() : ''}}"
        [style.backgroundColor]="getBackgroundStyle()"
        [style.backgroundImage]="image ? 'url(' + image + ')' : ''">
        <h3 class="mb-2">{{ title | locTranslate | stripHTML }}</h3>
        <div [innerHTML]="text | locTranslate"></div>
        <div>
            @for(link of links; track link) {
                @if(link.url) {
                    <button type="button" class="btn btn-lg btn-{{ link.color&&!link.color.includes('#') ? link.color : 'primary' }} mx-1" (click)="onLinkClick(link)" [style.backgroundColor]="link.color.includes('#') ? link.color : null" [style.borderColor]="link.color.includes('#') ? link.color : null">{{link.text}}</button>
                }
            }
        </div>
        <div class="TotemWidgetWelcome-Socials">
            @for(social of (socials | keyvalue); track social) {
                @if(social.value && social.value.url) {
                    <button type="button" class="btn btn-link text-{{ social.value.color }} mt-3 p-1" (click)="onSocialClick(social.key)" [attr.aria-label]="'totem-a11y.social' | locTranslate:'name':social.key">
                        <i class="fa-brands fa-{{social.key}} fa-fw" aria-hidden="true"></i>
                    </button>
                }
            }
        </div>
    </div>
</div>
